import { type PlaceDetails, type GooglePlace } from "types/quote-types";

export function getDestinationGooglePlacesSummary(
  placeResult: google.maps.places.PlaceResult,
  destination: GooglePlace,
) {
  const addressComponents = placeResult.address_components?.reduce(
    (result, component) => {
      const componentTypes = component.types;
      switch (true) {
        case componentTypes.includes("country"):
          result.country = component.short_name;
          break;
        case componentTypes.includes("locality"):
          result.locality = component.long_name;
          break;
        case componentTypes.includes("administrative_area_level_1"):
          result.areaLevel1 = component.short_name;
          break;
      }

      return result;
    },
    {
      country: "",
      areaLevel1: "",
      locality: "",
    },
  );

  return {
    ...addressComponents,
    googleId: destination.googleId,
    label: destination.label || (placeResult.formatted_address ?? ""),
  } as PlaceDetails;
}
